import { ApolloProvider } from '@apollo/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';

import apollo from './apollo';
import AutoScroll from './components/Atoms/AutoScroll';
import SentryErrorBoundary from './components/Atoms/SentryErrorBoundary';
import { LanguageProvider } from './contexts/LanguageContext';
import { MetaProvider } from './contexts/MetaContext';
import { WindowProvider } from './contexts/WindowContext';
import Routes from './routes';
import Layout from './views/Layout/Layout';

const App = () => (
  <SentryErrorBoundary>
    <ApolloProvider client={apollo}>
      <HelmetProvider>
        <LanguageProvider>
          <MetaProvider>
            <Router>
              <WindowProvider>
                <AutoScroll />
                <Layout>
                  <Routes />
                </Layout>
              </WindowProvider>
            </Router>
          </MetaProvider>
        </LanguageProvider>
      </HelmetProvider>
    </ApolloProvider>
  </SentryErrorBoundary>
);

export default App;
